import { httpClient } from '@/api/http-client'
import { DependentPayload } from '@/types'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'

type Params = {
  companyKey: string
  partnerKey: string
  dependentData: DependentPayload
}

export const updateDependent = async ({
  companyKey,
  partnerKey,
  dependentData,
}: Params) => {
  const response = await httpClient('accounting-dealer').post<DependentPayload>(
    `/v3/company/${companyKey}/partner/${partnerKey}/dependent`,
    dependentData,
  )
  return response.data
}

export const useUpdateDependent = (
  options?: UseMutationOptions<DependentPayload, AxiosError, Params>,
) => {
  return useMutation({
    mutationFn: updateDependent,
    ...options,
  })
}
